import firebase from './firebase';
import 'firebase/compat/storage';

const storage = firebase.storage();

//if (process.env.NODE_ENV === 'development') {
//    firebase.storage().useEmulator('localhost', 9199);
//    console.log('STORAGE DE EMULADOR');
//}

export default storage;
